/**
 * @generated SignedSource<<b39cd9f658428d36a2512486ab8d72b4>>
 * @relayHash bec7df53ca83812b5cc78b45964f54a4
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 286e9b8dd8f6f20eb2141d25ad97826dc8ef0bc66a72d8e575785c70c03d8023

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type AccountStatus = "active" | "closed" | "inactive" | "%future added value";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateSingleSelectUserPickerFieldInput = {
  id: string;
  operation: JiraSingleSelectUserPickerFieldOperationInput;
};
export type JiraSingleSelectUserPickerFieldOperationInput = {
  accountId?: string | null | undefined;
  id?: string | null | undefined;
  operation: JiraSingleValueFieldOperations;
};
export type assignee_issueFieldAssignee_AssigneeField_Mutation$variables = {
  input: JiraUpdateSingleSelectUserPickerFieldInput;
};
export type assignee_issueFieldAssignee_AssigneeField_Mutation$data = {
  readonly jira: {
    readonly updateSingleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly user: {
          readonly accountId: string;
          readonly accountStatus: AccountStatus;
          readonly id: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assignee_issueFieldAssignee_AssigneeField_Mutation$rawResponse = {
  readonly jira: {
    readonly updateSingleSelectUserPickerField: {
      readonly errors: ReadonlyArray<{
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly user: {
          readonly __typename: string;
          readonly accountId: string;
          readonly accountStatus: AccountStatus;
          readonly id: string;
          readonly name: string;
          readonly picture: AGG$URL;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type assignee_issueFieldAssignee_AssigneeField_Mutation = {
  rawResponse: assignee_issueFieldAssignee_AssigneeField_Mutation$rawResponse;
  response: assignee_issueFieldAssignee_AssigneeField_Mutation$data;
  variables: assignee_issueFieldAssignee_AssigneeField_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "concreteType": "MutationError",
  "kind": "LinkedField",
  "name": "errors",
  "plural": true,
  "selections": [
    {
      "kind": "ScalarField",
      "name": "message"
    }
  ]
},
v4 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "picture"
},
v7 = {
  "kind": "ScalarField",
  "name": "accountStatus"
},
v8 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraSingleSelectUserPickerFieldPayload",
            "kind": "LinkedField",
            "name": "updateSingleSelectUserPickerField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              {
                "concreteType": "JiraSingleSelectUserPickerField",
                "kind": "LinkedField",
                "name": "field",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "name": "user",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ]
                  },
                  (v8/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "286e9b8dd8f6f20eb2141d25ad97826dc8ef0bc66a72d8e575785c70c03d8023",
    "metadata": {},
    "name": "assignee_issueFieldAssignee_AssigneeField_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "62cbc1d7150c21a456232c86f0554a51";

export default node;
